<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold padding-sm align-items-center text-sm d-flex justify-content-between catalogo-text"
          >
            Lote
            <router-link :to="{ name: 'Section' }">
              <CButton color="primary" class="mr-1 btn-header">
                <CIcon class="mr-1" name="cil-arrow-thick-left" />Regresar
              </CButton>
            </router-link>
          </CCardHeader>

          <CCardBody v-if="isLoadingPage">
            <div class="w-100 d-flex justify-content-center align-items-center">
              <div class="sk-flow">
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
              </div>
            </div>
          </CCardBody>
          <CCardBody v-else>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <CInput
                  :value.sync="$v.nombreLote.$model"
                  :isValid="checkIfValid('nombreLote')"
                  v-model="nombreLote"
                  label="Nombre del lote:"
                  placeholder="Nombre..."
                  invalidFeedback="Campo requerido, debe tener al menos 2 caracteres y maximo 25 caracteres"
                />
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="12" md="9" lg="9">
                <CInput
                  :value.sync="$v.produccionObjetivo.$model"
                  :isValid="checkIfValid('produccionObjetivo')"
                  label="Producción objetivo:"
                  placeholder="Producción objetivo..."
                  type="number"
                  invalidFeedback="Campo requerido"
                />
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="12" md="9" lg="9">
                <CInput
                  :value.sync="$v.ingresosObjectivo.$model"
                  :isValid="checkIfValid('ingresosObjectivo')"
                  append=".00"
                  prepend="$"
                  label="Ingresos objetivo:"
                  placeholder="Costo objetivo.."
                  type="number"
                  invalidFeedback="Campo requerido"
                />
              </CCol>
            </CRow>
            <!-- <CRow>
              <CCol sm="12" md="9" lg="9">
                <label>Cultivo:</label>
                <v-select
                  v-model="cultivo"
                  :options="cultivos"
                  @input="getEtapas()"
                  class="margin-multi"
                  placeholder="Selecciona una cultivo"
                />
              </CCol>
            </CRow>-->

            <CRow>
              <CCol sm="12" md="9" lg="9">
                <label>Ubicaciones:</label>
                <div class="d-flex margin-multi align-items-center">
                  <multiselect
                    v-model="multi"
                    :options="ubicaciones"
                    :multiple="true"
                    :loading="isLoadingCombos"
                    label="label"
                    track-by="label"
                    placeholder="Selecciona uno o varias ubicaciones"
                  >
                    <template #no-options>Sin resultados.</template>
                  </multiselect>
                  <transition name="fade">
                    <div v-show="multi && multi.length" @click="cleanMulti()">
                      <CIcon size="lg" class="ml-2 cursor-p" name="cil-trash" />
                    </div>
                  </transition>
                </div>
              </CCol>
            </CRow>
            <hr class="my-4 line" />
            <CRow class="mb-3">
              <CCol md="10" lg="10">
                <CInput
                  :isValid="checkIfValid('nombreEtapa')"
                  :value.sync="$v.nombreEtapa.$model"
                  v-model="nombreEtapa"
                  placeholder="Etapa..."
                  invalidFeedback="Campo requerido, debe tener al menos 3 caracteres y maximo 25 caracteres"
                ></CInput>
              </CCol>

              <CCol alignHorizontal="end" md="2" lg="2">
                <CButton class="float-right" @click="addEtapa()" color="success" square>Agregar</CButton>
              </CCol>
            </CRow>
            <CRow class="mb-3">
              <CCol sm="12">
                <CDataTable
                  hover
                  sorter
                  bordered
                  small
                  fixed
                  :items="etapasLote"
                  :fields="fieldsSecondModal"
                >
                  <template #etapa="{item}">
                    <td class="py-2">{{ item.nombre }}</td>
                  </template>
                  <template #presupuesto="{item,index}">
                    <td @click="togglePresupuesto(item, index)" class="py-2">{{ item.presupuesto }}</td>
                  </template>
                  <template #fecha_inicial="{item, index}">
                    <td
                      v-if="index === 0"
                      @click="toggleFechaIni(item, index)"
                      class="py-2"
                    >{{ transformDate(item.fecha_inicial) }}</td>
                    <td v-else class="py-2">{{ transformDate(item.fecha_inicial) }}</td>
                  </template>
                  <template #fecha_final="{item, index}">
                    <td
                      @click="toggleFechaFin(item, index)"
                      class="py-2"
                    >{{ transformDate(item.fecha_final) }}</td>
                  </template>
                  <template #cancel="{index}">
                    <td class="py-2">
                      <CButton color="danger" square size="sm" @click="deleteEtapa(index)">Borrar</CButton>
                    </td>
                  </template>
                </CDataTable>
              </CCol>
            </CRow>
          </CCardBody>
          <CCardFooter class="d-flex justify-content-center">
            <router-link :to="{ name: 'Section' }">
              <CButton class="px-4 mx-3 btn-lg" color="danger">Cancelar</CButton>
            </router-link>

            <CButton @click="addLote()" class="px-4 mx-3 btn-lg" color="success">
              <div v-if="isLoading">
                <div class="w-100 d-flex justify-content-center align-items-center">
                  <div class="sk-flow height-custom flex align-items-center">
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                    <div class="sk-flow-dot bg-load-white"></div>
                  </div>
                </div>
              </div>
              <span v-else>Guardar</span>
            </CButton>
          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>

    <CModal
      :show.sync="presupuestoModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Presupuesto"
      color="primary"
    >
      <CRow>
        <CCol>
          <CInput
            v-model="presupuestoEtapa"
            append=".00"
            prepend="$"
            label="Presupuesto:"
            placeholder="Presupuesto.."
            type="number"
          />
        </CCol>
      </CRow>
      <template #header>
        <h5 class="modal-title">Asignar presupuesto {{ itemModal.name }}</h5>
        <CButtonClose @click="presupuestoModal = false" class="text-white" />
      </template>
      <template #footer>
        <CButton @click="presupuestoModal = false" color="danger">Cancelar</CButton>
        <CButton @click="setPresupuesto(itemModal.index)" color="success">Aceptar</CButton>
      </template>
    </CModal>

    <CModal
      :show.sync="fechaIniModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Presupuesto"
      color="primary"
    >
      <CRow>
        <CCol>
          <CInput
            v-model="fechaIniEtapa"
            label="Fecha inicial:"
            type="date"
            :horizontal="{ input: 'col-sm-12' }"
          />
        </CCol>
      </CRow>
      <template #header>
        <h5 class="modal-title">Fecha Inicial {{ itemModal.name }}</h5>
        <CButtonClose @click="fechaIniModal = false" class="text-white" />
      </template>
      <template #footer>
        <CButton @click="fechaIniModal = false" color="danger">Cancelar</CButton>
        <CButton @click="setFechaInicial(itemModal.index)" color="success">Aceptar</CButton>
      </template>
    </CModal>

    <CModal
      :show.sync="fechaFinModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Fin final"
      color="primary"
    >
      <CRow>
        <CCol>
          <CInput
            v-model="fechaFinEtapa"
            label="Fecha final:"
            type="date"
            :horizontal="{ input: 'col-sm-12' }"
          />
        </CCol>
      </CRow>
      <template #header>
        <h5 class="modal-title">Fecha final {{ itemModal.name }}</h5>
        <CButtonClose @click="fechaFinModal = false" class="text-white" />
      </template>
      <template #footer>
        <CButton @click="fechaFinModal = false" color="danger">Cancelar</CButton>
        <CButton @click="setFechaFinal(itemModal.index)" color="success">Aceptar</CButton>
      </template>
    </CModal>

    <CModal
      size="sm"
      title="Lote"
      :centered="true"
      color="warning"
      :show.sync="warningModal"
    >{{ error }}</CModal>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";

import { validationMixin } from "vuelidate";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
// import vSelect from "vue-select";
// import "vue-select/dist/vue-select.css";
import moment from "moment";

const fieldsSecondModal = [
  { key: "etapa", _style: "width:25%" },
  { key: "presupuesto", _style: "width:25%" },
  { key: "fecha_inicial", _style: "width:25%" },
  { key: "fecha_final", _style: "width:25%" },
  {
    key: "cancel",
    label: "",
    _style: "width:1%",
    sorter: false,
    filter: false
  }
];

export default {
  name: "NuevoLote",

  components: {
    Multiselect
    // vSelect
  },

  data() {
    return {
      id: this.$route.params.id,
      item: {},
      nombreLote: "",
      produccionObjetivo: 0,
      ingresosObjectivo: 0,
      ubicaciones: [],
      ubicacionesLote: [],
      ubicacionesAll: [],
      cultivos: [],
      cultivosAll: [],
      cultivo: null,
      etapasCultivo: [],
      etapasLote: [],
      nombreEtapa: "",
      fieldsSecondModal,
      presupuestoEtapa: 0,
      fechaIniEtapa: null,
      fechaFinEtapa: null,
      etapas: [],
      presupuestoModal: false,
      fechaIniModal: false,
      fechaFinModal: false,
      multi: null,
      isLoading: false,
      isLoadingPage: false,
      isLoadingCombos: false,
      warningModal: false,
      error: "",
      itemModal: { name: "", index: "" },
      indexModal: 0
    };
  },

  mixins: [validationMixin],
  validations: {
    nombreLote: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(25)
    },
    produccionObjetivo: {
      required
    },
    ingresosObjectivo: {
      required
    },
    nombreEtapa: {
      required,
      minLength: minLength(3),
      maxLength: maxLength(25)
    }
  },

  computed: {
    isValidLote() {
      return !this.$v.nombreLote.$invalid;
    },
    isValidProduccion() {
      return !this.$v.produccionObjetivo.$invalid;
    },
    isValidIngresos() {
      return !this.$v.ingresosObjectivo.$invalid;
    },
    isValidEtapa() {
      return !this.$v.nombreEtapa.$invalid;
    },
    ubicacionRaiz() {
      return this.$store.state.rootLocation;
    },
    ubicacionRaizValue() {
      return this.$store.state.rootLocation
        ? this.$store.state.rootLocation.value
        : "";
    }
  },

  created() {
    const ubicacionTemplateRaiz = this.$store.dispatch("customHTTP", {
      schema: "ubicaciones",
      filter: {
        where: [
          {
            field: "payload->raiz_id",
            value: this.ubicacionRaizValue,
            operator: "="
          },
          {
            field: "payload->suspendido",
            value: false,
            operator: "="
          }
        ]
      },
      order:[{
        field: 'payload->nombre',
        direction: 'asc'
      }]
    });
    const ubicacionTemplateNoRaiz = this.$store.dispatch("customHTTP", {
      schema: "ubicaciones",
      filter: {
        where: [
          {
            field: "payload->suspendido",
            value: false,
            operator: "="
          }
        ]
      },
      order:[{
        field: 'payload->nombre',
        direction: 'asc'
      }]
    });
    this.isLoadingPage = true;
    this.$store;

    const ubi = [
      this.$store.dispatch("customHTTP", { schema: "cultivos" }),

      this.$store.dispatch("customHTTP", {
        schema: "lotes",
        filter: {
          where: [
            {
              field: "id",
              value: this.id,
              operator: "="
            }
          ]
        }
      })
    ];

    if (this.ubicacionRaizValue) {
      ubi.push(ubicacionTemplateRaiz);
    } else {
      ubi.push(ubicacionTemplateNoRaiz);
    }

    Promise.all(ubi)
      .then(([cultivos, item, ubicaciones]) => {
        this.cultivos = cultivos.data.map(cultivo => {
          return { value: cultivo.id, label: cultivo.payload.nombre };
        });
        this.item = item.data[0];
        this.nombreLote = this.item.payload.nombre;
        this.produccionObjetivo = this.item.payload.produccion_objetivo;
        this.ingresosObjectivo = this.item.payload.ingresos_objetivo;
        // this.cultivo = this.item.payload.cultivo_id;
        this.cultivo = this.cultivos.find(
          cul => cul.value == this.item.payload.cultivo_id
        );
        this.etapasLote = this.item.payload.etapas.map(etapa => {
          return {
            nombre: etapa.nombre,
            presupuesto: etapa.presupuesto,
            fecha_final: new Date(etapa.fecha_final),
            fecha_inicial: new Date(etapa.fecha_inicial)
          };
        });
        this.cultivosAll = cultivos.data;
        const newUbi = [];

        // const newMult = this.item.payload.ubicaciones.map(u => {
        //   return ubicaciones.data
        //     .filter(ubi => ubi.id == u)
        //     .map(ubicacion => {
        //       return { value: ubicacion.id, label: ubicacion.payload.nombre };
        //     });
        // });
        console.log(newUbi);
        console.log(this.item.payload.ubicaciones);

        this.item.payload.ubicaciones.map(ubi => {
          newUbi.push(ubicaciones.data.find(item => item.id == ubi));
        });
        console.log(newUbi);

        // this.multi = newMult[0];
        this.multi = newUbi
          .filter(ubi => {
            if (ubi) {
              return true;
            } else {
              return false;
            }
          })
          .map(ubicacion => {
            return { value: ubicacion.id, label: ubicacion.payload.nombre };
          });

        this.ubicaciones = ubicaciones.data.map(ubicacion => {
          return { value: ubicacion.id, label: ubicacion.payload.nombre };
        });
        this.ubicacionesAll = ubicaciones.data;
        // this.changeMulti();
      })
      .finally(() => (this.isLoadingPage = false));
  },

  watch: {
    ubicacionRaiz: function() {
      this.updateCombos();
    }
  },

  methods: {
    transformDate(date) {
      return date.toLocaleDateString();
    },
    togglePresupuesto(item, index) {
      this.presupuestoModal = true;
      const itemIndex = {
        name: item.nombre,
        index: index
      };
      this.itemModal = itemIndex;
      this.presupuestoEtapa = this.etapasLote[index].presupuesto;
    },
    toggleFechaIni(item, index) {
      this.fechaIniModal = true;
      let newDate = "";
      let year = this.etapasLote[index].fecha_inicial.getFullYear();
      let month = (
        "0" +
        (this.etapasLote[index].fecha_inicial.getMonth() + 1)
      ).slice(-2);
      let day = ("0" + this.etapasLote[index].fecha_inicial.getDate()).slice(
        -2
      );

      newDate = `${year}-${month}-${day}`;

      const itemIndex = {
        name: item.nombre,
        index: index
      };
      this.itemModal = itemIndex;
      this.fechaIniEtapa = newDate;
    },
    toggleFechaFin(item, index) {
      this.fechaFinModal = true;
      let newDate = "";
      let year = this.etapasLote[index].fecha_final.getFullYear();
      let month = (
        "0" +
        (this.etapasLote[index].fecha_final.getMonth() + 1)
      ).slice(-2);
      let day = ("0" + this.etapasLote[index].fecha_final.getDate()).slice(-2);

      newDate = `${year}-${month}-${day}`;

      const itemIndex = {
        name: item.nombre,
        index: index
      };
      this.itemModal = itemIndex;
      this.fechaFinEtapa = newDate;
    },
    getEtapas() {
      if (this.cultivo) {
        const etapaLote = this.cultivosAll.find(
          cult => cult.id == this.cultivo.value
        );

        const ubicacionLote = this.ubicacionesAll.filter(
          ubi => ubi.payload.cultivo_id == this.cultivo.value
        );

        const ubicacionesNew = ubicacionLote.map(ubicacion => {
          return { value: ubicacion.id, label: ubicacion.payload.nombre };
        });

        let etapasNew = [];
        let initialDate = new Date();

        etapaLote.payload.etapas.map(etapa => {
          etapasNew.push({
            nombre: etapa,
            fecha_final: new Date(
              initialDate.getFullYear(),
              initialDate.getMonth(),
              initialDate.getDate() + 1
            ),
            presupuesto: 0,
            fecha_inicial: initialDate
          });
          initialDate = new Date(
            initialDate.getFullYear(),
            initialDate.getMonth(),
            initialDate.getDate() + 2
          );
        });
        this.etapasLote = etapasNew;
        this.ubicaciones = ubicacionesNew;
        this.multi = [];
      } else {
        this.etapasLote = [];
        this.ubicaciones = this.ubicacionesAll.map(ubicacion => {
          return { value: ubicacion.id, label: ubicacion.payload.nombre };
        });
        this.multi = [];
      }
    },
    setPresupuesto(index) {
      this.etapasLote[index].presupuesto = this.presupuestoEtapa;
      this.presupuestoModal = false;
    },
    setFechaInicial(idx) {
      const iniDate = this.fechaIniEtapa.split("-");
      iniDate.map(i => i * 1);

      this.etapasLote[idx].fecha_inicial = new Date(iniDate.map(i => i * 1));
      this.fechaIniModal = false;
    },
    setFechaFinal(idx) {
      const lastIndex = this.etapasLote.length - 1;
      const finDate = this.fechaFinEtapa.split("-");

      let finalDate = new Date(finDate.map(i => i * 1));

      if (finalDate <= this.etapasLote[idx].fecha_inicial) {
        finalDate = new Date(this.etapasLote[idx].fecha_inicial);
        finalDate.setDate(finalDate.getDate() + 1);
      }
      let nextDay = new Date(finalDate);
      nextDay.setDate(nextDay.getDate() + 1);

      this.etapasLote[idx].fecha_final = finalDate;
      if (idx + 1 <= lastIndex) {
        this.etapasLote[idx + 1].fecha_inicial = nextDay;
      }
      this.fechaFinModal = false;
    },
    addLote() {
      this.validateLote();

      if (this.isValidLote && this.isValidProduccion && this.isValidIngresos) {
        // if (!this.cultivo) {
        //   this.error = "El campo cultivo es obligatorio";
        //   this.warningModal = true;
        //   return;
        // }

        this.isLoading = true;
        let valueUbicaciones = this.multi.map(item => item.value);
        let valueEtapas = this.etapasLote.map(etapa => {
          return {
            nombre: etapa.nombre,
            presupuesto: Number(etapa.presupuesto),
            fecha_inicial: moment(etapa.fecha_inicial).format("YYYY-MM-DD"),
            // etapa.fecha_inicial.getFullYear() +
            // "-" +
            // (etapa.fecha_inicial.getMonth() + 1) +
            // "-" +
            // etapa.fecha_inicial.getDate(),
            // fecha_inicial: etapa.fecha_inicial.toISOString().slice(0, -5),
            // fecha_final: etapa.fecha_final.toISOString().slice(0, -5)
            fecha_final: moment(etapa.fecha_final).format("YYYY-MM-DD")
            // etapa.fecha_final.getFullYear() +
            // "-" +
            // (etapa.fecha_final.getMonth() + 1) +
            // "-" +
            // etapa.fecha_final.getDate()
          };
        });
        console.log(valueEtapas);
        // console.log({
        //   schema: "lotes",
        //   id: this.id,
        //   payload: {
        //     nombre: this.nombreLote,
        //     cultivo_id: this.cultivo ? this.cultivo.value : "",
        //     ingresos_objetivo: Number(this.ingresosObjectivo),
        //     produccion_objetivo: Number(this.produccionObjetivo),
        //     ubicaciones: valueUbicaciones,
        //     etapas: valueEtapas
        //   }
        // });

        // console.log({
        //   schema: "lotes",
        //   id: this.id,
        //   payload: {
        //     nombre: this.nombreLote,
        //     cultivo_id: this.cultivo ? this.cultivo.value : "",
        //     ingresos_objetivo: Number(this.ingresosObjectivo),
        //     produccion_objetivo: Number(this.produccionObjetivo),
        //     ubicaciones: valueUbicaciones,
        //     etapas: valueEtapas
        //   }
        // });

        this.$store
          .dispatch("customRemplazarHTTP", {
            schema: "lotes",
            id: this.id,
            payload: {
              nombre: this.nombreLote,
              // cultivo_id: this.cultivo ? this.cultivo.value : "",
              ingresos_objetivo: Number(this.ingresosObjectivo),
              produccion_objetivo: Number(this.produccionObjetivo),
              ubicaciones: valueUbicaciones,
              etapas: valueEtapas
            }
          })
          .then(() => {
            // console.log(.data);
            this.$router.push({ name: "Section" });
          })
          .catch(rej => {
            this.error = rej.message;
            this.warningModal = true;
          })

          .finally(() => {
            this.isLoading = false;
          });
      }
    },
    changeMulti() {
      let newUbicaciones = [];
      let selectedUbi = [];

      this.multi[0]
        ? ((selectedUbi = this.ubicacionesAll.find(
            ubi => ubi.id == this.multi[0].value
          )),
          (newUbicaciones = this.ubicacionesAll.filter(
            ubi =>
              ubi.payload.raiz_id == selectedUbi.payload.raiz_id &&
              ubi.payload.cultivo_id == this.cultivo.value
          )))
        : (newUbicaciones = this.ubicacionesAll.filter(
            ubi => ubi.payload.cultivo_id == this.cultivo.value
          ));

      const ubicacionesNew = newUbicaciones.map(ubicacion => {
        return { value: ubicacion.id, label: ubicacion.payload.nombre };
      });
      this.ubicaciones = ubicacionesNew;
    },
    checkIfValid(fieldName) {
      const field = this.$v[fieldName];
      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    validateLote() {
      this.$v.nombreLote.$touch();
      this.$v.produccionObjetivo.$touch();
      this.$v.ingresosObjectivo.$touch();
      // this.$v.equivalencia_6oz.$touch();
    },
    addEtapa() {
      this.validateEtapa();
      if (this.isValidEtapa) {
        let etapasNew = [...this.etapasLote];
        let initialDate = new Date();

        if (etapasNew.length) {
          initialDate = etapasNew[etapasNew.length - 1].fecha_final;
          initialDate = new Date(
            initialDate.getFullYear(),
            initialDate.getMonth(),
            initialDate.getDate() + 1
          );
        }

        etapasNew.push({
          nombre: this.nombreEtapa,
          fecha_final: new Date(
            initialDate.getFullYear(),
            initialDate.getMonth(),
            initialDate.getDate() + 1
          ),
          presupuesto: 0,
          fecha_inicial: initialDate
        });
        initialDate = new Date(
          initialDate.getFullYear(),
          initialDate.getMonth(),
          initialDate.getDate() + 2
        );
        this.etapasLote = etapasNew;
        this.resetEtapa();
      }
    },
    validateEtapa() {
      this.$v.nombreEtapa.$touch();
    },
    resetEtapa() {
      this.nombreEtapa = "";
      this.$v.nombreEtapa.$reset();
    },
    deleteEtapa(index) {
      const etapaAnterior = this.etapasLote[index - 1];
      const etapaSiguiente = this.etapasLote[index + 1];
      console.log(etapaAnterior);
      console.log(etapaSiguiente);
      console.log(index);
      if (!etapaSiguiente && !etapaAnterior) {
        if (index !== -1) {
          this.etapasLote.splice(index, 1);
        }
        return;
      }

      if (!etapaAnterior) {
        this.etapasLote[index + 1].fecha_inicial = this.etapasLote[
          index
        ].fecha_inicial;
      }
      if (!etapaSiguiente) {
        this.etapasLote[index - 1].fecha_final = this.etapasLote[
          index
        ].fecha_final;
      }
      if (etapaSiguiente && etapaAnterior) {
        this.etapasLote[index - 1].fecha_final = this.etapasLote[
          index
        ].fecha_final;
      }
      if (index !== -1) {
        this.etapasLote.splice(index, 1);
      }
    },
    updateCombos() {
      const ubicacionTemplateRaiz = this.$store.dispatch("customHTTP", {
        schema: "ubicaciones",
        filter: {
          where: [
            {
              field: "payload->raiz_id",
              value: this.ubicacionRaizValue,
              operator: "="
            },
            {
              field: "payload->suspendido",
              value: false,
              operator: "="
            }
          ]
        },
        order:[{
          field: 'payload->nombre',
          direction: 'asc'
        }]
      });
      const ubicacionTemplateNoRaiz = this.$store.dispatch("customHTTP", {
        schema: "ubicaciones",
        filter: {
          where: [
            {
              field: "payload->suspendido",
              value: false,
              operator: "="
            }
          ]
        },
        order:[{
          field: 'payload->nombre',
          direction: 'asc'
        }]
      });

      this.isLoadingCombos = true;
      this.$store;

      const ubi = [];

      if (this.ubicacionRaizValue) {
        ubi.push(ubicacionTemplateRaiz);
      } else {
        ubi.push(ubicacionTemplateNoRaiz);
      }

      Promise.all(ubi)
        .then(([ubicaciones]) => {
          this.ubicaciones = ubicaciones.data.map(ubicacion => {
            return { value: ubicacion.id, label: ubicacion.payload.nombre };
          });
          this.ubicacionesAll = ubicaciones.data;
        })
        .finally(() => (this.isLoadingCombos = false));
    },
    cleanMulti() {
      this.multi = [];
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.margin-multi {
  margin-bottom: 1rem !important;
}
.bg-load-white {
  background-color: white !important;
}
.height-custom {
  height: 25px;
}
@media (max-width: 420px) {
  .btn-header {
    padding-left: 8px;
    padding-right: 8px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 8px;
    padding-right: 8px;
  }
  .text-sm {
    font-size: 16px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
